import React, { FC } from 'react'

import { LineLimitTxt } from 'src/components/atoms'
import { Checkbox } from 'src/components/atoms/inputs/Checkbox'
import { CompassRoleDropdown, ProjectStatusTxt } from 'src/components/molecules'

import { CompassRoleType, ProjectEntity } from 'src/types'
import { CompassRoleEntity } from 'src/types/entities/CompassRole'

type Props = {
  project: ProjectEntity | undefined
  compassRoles: CompassRoleEntity[]
  selectedValue: number | undefined
  isAlreadyAssigned: boolean
  isSelected: boolean
  compassRoleErrorMessage?: string
  selectOption: (compassRoles: CompassRoleType | undefined) => void
  select: () => void
  className?: string
}

export const UserAssignProjectListItem: FC<Props> = ({
  project,
  compassRoles,
  selectedValue,
  isAlreadyAssigned,
  isSelected,
  compassRoleErrorMessage,
  selectOption,
  select,
  className,
}) => {
  const handleSelectOption = (compassRoleId: number | undefined) => {
    const compassRole = compassRoles.find(role => role.id === compassRoleId)
    selectOption(compassRole)
  }

  return (
    <div className={className}>
      <div className="tw-py-s-1 tw-px-s0">
        <div className="tw-flex tw-items-center tw-relative tw-gap-s0">
          {!isAlreadyAssigned && (
            <div className="tw-absolute tw-top-0 -tw-left-s-3 tw-bg-errorRed-default tw-w-[10px] tw-aspect-square tw-rounded-full" />
          )}
          <Checkbox checked={isSelected} onChange={select} />
          <LineLimitTxt maxLineLimit={2} className="tw-font-bold tw-w-full">
            {project?.name ?? ''}
          </LineLimitTxt>
          <div className="tw-w-s5 tw-font-bold tw-shrink-0">
            {project?.status && <ProjectStatusTxt status={project.status} />}
          </div>
          <div className="tw-inline-flex tw-items-center tw-shrink-0">
            <CompassRoleDropdown
              compassRoles={compassRoles}
              value={selectedValue}
              errorMessage={compassRoleErrorMessage}
              selectOption={handleSelectOption}
              className="tw-w-[12.86rem]"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
